// Mint app theme for admin surfaces (/people, /people/edit, /users).
// Uses a mint green + petrol blue palette with nightfall/limestone accents.
const tailwindColors = require('tailwindcss/colors');

module.exports = {
  colors: {
    main: {
      light: '#D1F5EA',
      dark: '#06041F',
    },
    card: {
      light: '#ffffff',
      dark: '#0d0a2d',
    },
    surface: {
      light: '#A3EBD5',
      dark: '#13294B',
    },
    action: {
      light: '#47D7AC',
      dark: '#47D7AC',
    },
    actionHover: {
      light: '#3AAB94',
      dark: '#75E1C1',
    },
    textPrimary: {
      light: '#06041F',
      dark: '#D1F5EA',
    },
    textSecondary: {
      light: '#13294B',
      dark: '#A3EBD5',
    },
    textMuted: {
      light: '#205463',
      dark: '#C4C9D2',
    },
    textMutedSubtle: {
      light: '#2D807B',
      dark: '#9AA4B5',
    },
    border: {
      light: '#75E1C1',
      dark: '#205463',
    },
    borderSubtle: {
      light: '#A3EBD5',
      dark: '#2D807B',
    },
    success: {
      light: tailwindColors.emerald[600],
      dark: tailwindColors.emerald[500],
    },
    successHover: {
      light: tailwindColors.emerald[700],
      dark: tailwindColors.emerald[600],
    },
    successBg: {
      light: tailwindColors.emerald[50],
      dark: 'rgba(6, 78, 59, 0.3)',
    },
    successText: {
      light: tailwindColors.emerald[500],
      dark: tailwindColors.emerald[400],
    },
    successBorder: {
      light: tailwindColors.emerald[200],
      dark: tailwindColors.emerald[800],
    },
    error: {
      light: tailwindColors.rose[600],
      dark: tailwindColors.rose[500],
    },
    errorHover: {
      light: tailwindColors.rose[700],
      dark: tailwindColors.rose[600],
    },
    errorBg: {
      light: tailwindColors.rose[50],
      dark: 'rgba(136, 19, 55, 0.3)',
    },
    errorText: {
      light: tailwindColors.rose[500],
      dark: tailwindColors.rose[400],
    },
    errorBorder: {
      light: tailwindColors.rose[200],
      dark: tailwindColors.rose[800],
    },
    info: {
      light: '#13294B',
      dark: '#75E1C1',
    },
    infoHover: {
      light: '#205463',
      dark: '#A3EBD5',
    },
    infoBg: {
      light: '#D1F5EA',
      dark: 'rgba(19, 41, 75, 0.35)',
    },
    infoText: {
      light: '#13294B',
      dark: '#A3EBD5',
    },
    infoBorder: {
      light: '#75E1C1',
      dark: '#205463',
    },
    link: {
      light: '#13294B',
      dark: '#75E1C1',
    },
    linkBg: {
      light: '#D1F5EA',
      dark: 'rgba(71, 215, 172, 0.18)',
    },
    linkBorder: {
      light: '#A3EBD5',
      dark: '#205463',
    },
    linkHover: {
      light: '#A3EBD5',
      dark: '#2D807B',
    },
    inputBg: {
      light: '#ffffff',
      dark: '#13294B',
    },
    inputBorder: {
      light: '#75E1C1',
      dark: '#205463',
    },
    inputText: {
      light: '#06041F',
      dark: '#D1F5EA',
    },
    focusRing: {
      light: '#47D7AC',
      dark: '#75E1C1',
    },
    overlay: {
      light: 'rgba(6, 4, 31, 0.6)',
      dark: 'rgba(6, 4, 31, 0.82)',
    },
    confirm: {
      light: '#C4C9D2',
      dark: '#205463',
    },
    confirmHover: {
      light: '#b2b8c2',
      dark: '#2D807B',
    },
    confirmText: {
      light: '#06041F',
      dark: '#D1F5EA',
    },
    confirmBg: {
      light: '#D1F5EA',
      dark: '#13294B',
    },
    confirmBorder: {
      light: '#A3EBD5',
      dark: '#205463',
    }
  },
  borderRadius: {
    card: '40px',
    container: '25px',
    page: '1.5rem',
    button: '9999px',
    input: '0.75rem',
    badge: '6px',
    full: '9999px'
  },
  borderWidth: {
    default: '1px',
    thick: '2px',
    avatar: '6px',
    device: '8px'
  },
  textures: {
    main: {
      light: '',
      dark: '',
      size: '0',
      blendLight: 'normal',
      blendDark: 'normal',
      opacityLight: 0,
      opacityDark: 0
    },
    surface: {
      light: '',
      dark: ''
    },
    card: {
      light: '',
      dark: ''
    }
  }
};
